import Icon from '@atoms/Icon/Icon';
import Text from '@atoms/Text/Text';
import { IIconButton } from '@models/IIconButton';
import classNames from 'classnames';

const IconButton = ({
  className,
  dataTestId,
  href,
  label,
  icon,
  onClick,
}: IIconButton) => {
  const Component = href ? 'a' : 'button';

  return (
    <Component
      data-testid={dataTestId}
      href={href}
      type={href ? undefined : 'button'}
      onClick={() => onClick()}
      className={classNames(className, 'tw-flex tw-items-center tw-gap-3')}
    >
      <Icon name={icon} />
      <Text variant="body-small">{label}</Text>
    </Component>
  );
};

export default IconButton;
